import { defineComponent as _defineComponent } from 'vue'
import {PropType} from 'vue';
import {GetPackageContainerResponseType} from "@/api/responses/getPackageContainerResponse";
import { PackageContainerStatus } from '@/enums/PackageContainerTypes';


export default /*#__PURE__*/_defineComponent({
  __name: 'PackageContainerDetailsCard',
  props: {
  containerDetails: {
    type: Object as PropType<GetPackageContainerResponseType>,
    required: false,
  },
  requestUserToScan: {
    type: Boolean,
    required: true,
  }
},
  setup(__props) {

const props = __props;



return { __sfc: true,props, PackageContainerStatus }
}

})